import { render } from "./OcMessageArchive.vue?vue&type=template&id=626451f4&scoped=true"
import script from "./OcMessageArchive.vue?vue&type=script&lang=js"
export * from "./OcMessageArchive.vue?vue&type=script&lang=js"

import "./OcMessageArchive.vue?vue&type=style&index=0&id=626451f4&scoped=true&lang=css"

import exportComponent from "C:\\Apps\\AppBase\\app-base-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-626451f4"]])

export default __exports__